import * as React from 'react';
import * as Tgcc from '../tgccGlobal';
import {connect} from 'react-redux';
import Radium from 'radium';
import {browserHistory} from 'react-router';

const sliderStyle:React.CSSProperties = {
    width:'100%',
    position:'relative'
}
const slide1Back: React.CSSProperties = {
    width:'100%',
    position:'relative'
}
/*
const slide2Back: React.CSSProperties = {
    width:'100%',
    height:'425px',
}
const slide3Back: React.CSSProperties = {
    width:'100%',
    height:'425px',
}
const nextStyle:React.CSSProperties = {
    position:'relative',
    display:'inline-block',
    float:'right',
    height:'56px',
    cursor:'pointer'
}
const nextCantStyle: React.CSSProperties = {
    position:'relative',
    display:'inline-block',
    float:'right',
    height:'56px',
    opacity:.5
}
const previousStyle: React.CSSProperties = {
    position:'relative',
    display:'inline-block',
    height:'56px',
    transform: 'rotate(180deg)',
    cursor:'pointer'
}
const prevCantStyle: React.CSSProperties = {
    position:'relative',
    display:'inline-block',
    height:'56px',
    transform: 'rotate(180deg)',
    opacity:.5
}
const arrowWrap: React.CSSProperties = {
    position:'absolute',
    bottom:'40px',
    left:0,
    right:0,
    zIndex:10,
    height:'56px',
    pointerEvents:'none'
}
const img : React.CSSProperties = {
    height:'56px'
}
*/
const slide1BannerHdr: React.CSSProperties = {
    backgroundImage:'url(' + Tgcc.ResolveUrl('~/images/Indigo_Desk_2400.jpg') + ')',
    backgroundSize:'cover',
    backgroundRepeat:'no-repeat',
    backgroundPosition:'center'
}
const overlayPanel: React.CSSProperties = {
    backgroundColor:'#FFFFFF',
    width:'30%',
    position:'absolute',
    textAlign:'center',
    top:'50%',
    right:'8%',
    transform:'translateY(-50%)',
    zIndex:1,
    padding:'60px 20px 45px',
    boxSizing:'border-box'
}
const overlaySubtext: React.CSSProperties = {
    fontFamily:'AveriaSerifLightItalic',
    margin:'35px auto 35px',
    width:'70%'
}
/*
const thirdSlideImg: React.CSSProperties = {
    width:'75%',
    backgroundImage : 'url(' + Tgcc.ResolveUrl('~/images/Slide3GetStarted.jpg') + ')',
    backgroundPosition:'cover',
    backgroundSize:'cover',
    backgroundRepeat:'no-repeat',
    height:'100%'
}
const slide1Div2: React.CSSProperties = {
    backgroundColor:'#FFFFFF',
    height:'90%',
    width:'30%',
    position:'absolute',
    textAlign:'center',
    top:'20px',
    right:'8%'
}
const slide2Div2: React.CSSProperties = {
    backgroundColor:'#FFFFFF',
    height:'90%',
    width:'30%',
    position:'absolute',
    textAlign:'center',
    top:'20px',
    left:'8%'
}
*/
const slide1Btn: React.CSSProperties = {
    backgroundColor: '#F38F2E',
    color: 'white',
    width: '190px',
    height: '49px',
    margin: 'auto',
    textAlign: 'center',
    lineHeight: '3.2em',
    fontFamily: 'Reitam',
    cursor: 'pointer',
    border: '1px solid transparent'
}
const letsBtn = Object.assign({},slide1Btn,{width:'160px'});
const overlayTitle: React.CSSProperties = {
    fontFamily:'CoachellaRegular',
    textTransform:'uppercase',
    color:'#231F20',
    fontSize:'calc(20px + (36-24) * ((100vw - 320px) / (1980 - 320)))',
    marginTop:0,
    marginBottom:0
}
/*
const comfrtW: React.CSSProperties = {
    fontFamily:'CoachellaRegular',
    textTransform:'uppercase',
    color:'#231F20',
    fontSize:'calc(20px + (36-24) * ((100vw - 320px) / (1980 - 320)))',
    marginTop:'75px'
}
const knowIndigo = Object.assign({},comfrtW,{marginTop:'30px'});
const hdrStarted = Object.assign({},comfrtW,{marginTop:'50px'});
const avail: React.CSSProperties = {
    fontFamily:"AveriaSerifLightItalic",
    margin:'45px auto',
    width:'70%'
}
const newIndigo = Object.assign({},avail,{margin:'50px auto 10px',width:'unset'});
const bluebox: React.CSSProperties = {
    width:'25%',
    height:'100%',
    backgroundColor:'#3D6483'
}
const darkbox:React.CSSProperties = {
    width:'25%',
    height:'100%',
    backgroundColor:"#555960",
    float:'right'
}
const Slide2: React.CSSProperties = {
    width:'75%',
    backgroundImage : 'url(' + Tgcc.ResolveUrl('~/images/IndigoSlide2.png') + ')',
    backgroundPosition:'right',
    backgroundSize:'cover',
    backgroundRepeat:'no-repeat',
    height:'100%'
}
const backgroundDiv: React.CSSProperties = {
    height:'100%'
}
const backgroundDivHood: React.CSSProperties = {
    height:'100%',
    display:'flex'
}
*/
const getStarted: React.CSSProperties = {
    display:'flex',
    justifyContent:'space-around'
}

class _IndigoSlider extends React.Component<Tgcc.BaseProps, any> {
    // state: any = { slideCount: 1 };

    openNewDesign = () => {browserHistory.push(Tgcc.Routes.IndigoDesignListView)};
    // openRegister = () => {browserHistory.push(Tgcc.Routes.IndigoRegister)};
    // openLogin = () => {browserHistory.push(Tgcc.Routes.IndigoLogin)};
    // openIndigo = () => {browserHistory.push(Tgcc.Routes.IndigoProductBrandView("Indigo Apparel"))};

    SlideOne(){
        return (
            <div style={slide1Back} className="indigoBannerWrap">
                <div style={slide1BannerHdr} className="indigoBannerHdr"></div>
                <div style={overlayPanel} className="indigoTopBanner">
                    <div style={overlayTitle}>NEW DESIGNS</div>
                    <div style={getStarted}>
                        <div>
                            <p style={overlaySubtext}>Browse through our newest designs! Easy to personalize and ready to print.</p>
                            <div style={letsBtn} onClick={this.openNewDesign} className="corpGet">New Designs</div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    /*
    SlideTwo(){
        return (
            <div style={slide2Back}>
                <div style={slide2Div2} className="fallCorpBox">
                    <p style={knowIndigo}>GET TO KNOW INDIGO APPAREL</p>
                    <p style={avail}>Our premium 100% crafted in America line of t-shirts is sure to be your best seller!</p>
                    <div style={slide1Btn} onClick={this.openIndigo}>Indigo</div>
                </div>
                <div style={backgroundDivHood}>
                    <div style={bluebox}></div>
                    <div style={Slide2}></div>
                </div>
            </div>
        )
    }
    SlideThree(){
        return (
            <div style={slide3Back}>
                <div style={slide1Div2} className="lets">
                    <div style={hdrStarted}>LETS GET STARTED</div>
                    <div style={getStarted}>
                        <div>
                            <p style={newIndigo}>New to Indigo Island?</p>
                            <div style={letsBtn} onClick={this.openRegister} className="corpGet">CREATE ACCOUNT</div>
                        </div>
                        <div>
                            <p style={newIndigo}>Existing Customer?</p>
                            <div style={letsBtn} onClick={this.openLogin} className="corpLog">Login</div>
                        </div>
                    </div>
                </div>
                <div style={backgroundDiv}>
                    <div style={darkbox}></div>
                    <div style={thirdSlideImg}></div>
                </div>
            </div>
        )
    }

    previousSlide = (evt: React.MouseEvent<HTMLDivElement>) => {
        if(this.state.slideCount < 1){
            this.setState({slideCount: 1})
        }
        else {
            this.setState({ slideCount: this.state.slideCount - 1 })
        }
    }
    nextSlide = (evt: React.MouseEvent<HTMLDivElement>) => {
        if(this.state.slideCount > 3){
            this.setState({slideCount: 1})
        }
        else {
            this.setState({ slideCount: this.state.slideCount + 1 })
        }
    }
    nextCheck() {
        if(this.state.slideCount < 1 || this.state.slideCount >=3){
            return(<div style={nextCantStyle} className="campusNext"><img src={Tgcc.ResolveUrl('~/images/sliderarrows.png')} style={img}/></div>)
        } else {
            return(<div onClick={this.nextSlide} style={nextStyle} className="campusNext"><img src={Tgcc.ResolveUrl('~/images/sliderarrows.png')} style={img}/></div>)
        }
    }
    previousCheck(){
        if(this.state.slideCount > 4 || this.state.slideCount <= 1){
            return(<div style={prevCantStyle} className='campusPrev'><img src={Tgcc.ResolveUrl('~/images/sliderarrows.png')} style={img}/></div>)
        } else {
            return(<div style={previousStyle} className='campusPrev' onClick={this.previousSlide}><img src={Tgcc.ResolveUrl('~/images/sliderarrows.png')}style={img}/></div>)
        }
    }
    */

    render() {
        return (
            <div style={sliderStyle} className='sliderStyle indigoSlider'>
                {this.SlideOne()}
                {/*
                { this.state.slideCount === 2 ? this.SlideTwo(): null }
                { this.state.slideCount === 3 ? this.SlideThree() : null}
                <div style={arrowWrap} className="slideArrowDiv">
                    {this.previousCheck()}
                    {this.nextCheck()}
                </div>
                */}
            </div>
        )
    }
}
const mapStateToProps = (state : Tgcc.GlobalState, ownState: any) => {
    return { state: state };
};

export var IndigoSlider = connect(mapStateToProps)(Radium(_IndigoSlider));
